export const PROJECTS_PAGE_SIZE = 6;

export const GenericErrorMessage = 'Oops! Something went wrong...';
